import React, { useContext } from "react";
import { AuthContext } from "../../AuthProvider";
import './HotWaterStart.css';
import Parse from "parse";

const HotWaterStart = () => {
    const { esp, updateUserEsp } = useContext(AuthContext);

    const toggle = () => {
        updateUserEsp(esp.id, { hotWater: { heatNow: esp.hotWater?.heatNow ? null : new Date() } })
            .then(() => {
                return Parse.Cloud.run("updateHotWaterHours", {
                    espId: esp.id,
                });
            })
            .catch(error => {
                console.error("Fel vid uppdatering av varmvattenstatus:", error);
            });
    };

    return (
        <>
            <button className="controlpanel-button" onClick={toggle} variant={esp?.hotWater?.heatNow ? "danger" : "primary"} disabled={esp?.hotWater?.automationStatus ? false : true}>
                <i className="bi bi-fire controlpanel-button-icon-water" style={{ color: esp?.hotWater?.automationStatus ? "#FF8C00" : "lightgrey", position: 'absolute', top: '-18%' }} />
                <span className="controlpanel-button-text" style={{ position: 'absolute', bottom: '10%' }}>{esp?.hotWater?.heatNow ? "Stoppa värmning" : "Värm nu"}</span>
            </button>
        </>

    )
}

export default HotWaterStart;


